
export const ERRORTYPES = {
    NETWORK: "network",
    UNAUTHORIZED: "unauthorized",
}